<ui-loading [active]="loading"></ui-loading>
              <section>
                <router-outlet></router-outlet>
              </section>